import { render, staticRenderFns } from "./EmailPartnerTariff.vue?vue&type=template&id=446ab1b3&"
import script from "./EmailPartnerTariff.vue?vue&type=script&lang=ts&"
export * from "./EmailPartnerTariff.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports